module.exports = __webpack_public_path__ + "img/52114124_L.86ca6234.png";